import { LogsListFilter } from './LogsListFilter'

const LogsListToolbar = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <LogsListFilter />

      {/* begin::Export */}
      {/* <button type='button' className='btn btn-light-primary me-3'>
        <KTIcon iconName='exit-up' className='fs-2' />
        Exportar
      </button> */}
      {/* end::Export */}

      {/* begin::Add user */}
      {/* <button type='button' className='btn btn-primary' onClick={openAddLogModal}>
        <KTIcon iconName='plus' className='fs-2' />
        Nuevo Log
      </button> */}
      {/* end::Add user */}
    </div>
  )
}

export { LogsListToolbar }
